import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { Message } from "semantic-ui-react";
import JoditEditor from "jodit-react";
import { observer } from "mobx-react";
import NestStore from "../../../stores/NestStore";

@observer
class FormEditor extends Component {
  handleOnChangeInput = e => {
    const { dataStore, castValue, name } = this.props;
    const value = castValue ? castValue(e) : e;
    _.set(dataStore, name, value);
    const error = _.get(dataStore.errorMessages, name, undefined);
    if (error) {
      _.unset(dataStore.errorMessages, name);
    }
  };

  render() {
    const { dataStore, defaultValue, name, label, castValue, parseValue, onChange, error, ...props } = this.props;
    const value = _.get(dataStore, name, defaultValue || "") || defaultValue || "";
    const valueError = _.get(dataStore.errorMessages, name, undefined);
    return (
      <>
        <div className="field">
          <label>{label}</label>
          {(valueError || error) && <Message negative content={valueError || error} />}
          <JoditEditor
            value={parseValue ? parseValue(value) : value}
            onChange={onChange || this.handleOnChangeInput}
            {...props}
          />
        </div>
      </>
    );
  }
}
FormEditor.propTypes = {
  dataStore: PropTypes.instanceOf(NestStore).isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  error: PropTypes.string,
  onChange: PropTypes.func,
  defaultValue: PropTypes.any,
  castValue: PropTypes.func, // could be useful if you want to cast a value entered
  parseValue: PropTypes.func, // could be useful if you want to parse value to form value
};
export default FormEditor;
